export const AUCUN_MOUVEMENT_ID = 'f5e0dff0-7a84-4893-bb26-99481c159978';
export const ACCEPT_LD_JSON = 'application/ld+json';
export const CONTENT_DISPOSITION_HEADER = 'content-disposition';
export const VIEWS_PAGE_NOTIFICATION = 'views.pageNotification.';
